import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';

interface Props {
  articleType: 'QUESTION' | 'ARTICLE' | 'DISCUSSION';
}

const ArticleType = ({ articleType }: Props) => {
  return (
    <span
      css={[
        baseArticleTypeStyle,
        articleType === 'QUESTION' && questionStyle,
        articleType === 'ARTICLE' && articleStyle,
        articleType === 'DISCUSSION' && discussionStyle,
      ]}
    >
      {articleType}
    </span>
  );
};

const baseArticleTypeStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px 8px',
  fontSize: '11px',
  fontWeight: 500,
  borderRadius: '4px',
  textTransform: 'uppercase' as const,
  color: token('color.text.inverse'),
  fontFamily: 'Inter, sans-serif',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '10px',
    padding: '3px 6px',
  },
});

const questionStyle = css({
  backgroundColor: token('color.background.warning.bold'),
});

const articleStyle = css({
  backgroundColor: token('color.background.information.bold'),
});

const discussionStyle = css({
  backgroundColor: token('color.background.discovery.bold'),
});

export default ArticleType;
